import { render, staticRenderFns } from "./RelatedPersonTab.vue?vue&type=template&id=66bf4056&scoped=true&"
import script from "./RelatedPersonTab.vue?vue&type=script&lang=js&"
export * from "./RelatedPersonTab.vue?vue&type=script&lang=js&"
import style0 from "./RelatedPersonTab.vue?vue&type=style&index=0&id=66bf4056&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bf4056",
  null
  
)

export default component.exports